import {
  DocumentNode,
  OperationVariables,
  QueryHookOptions,
  TypedDocumentNode,
  useQuery,
} from '@apollo/client';
import { useAuth } from 'context/auth';

export function useQueryWhenAuthed<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- generic default matches Apollo's useQuery API; callers specify types when needed
  TData = any,
  TVariables extends OperationVariables = OperationVariables
>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options: QueryHookOptions<TData, TVariables> = Object.create(null)
) {
  const { isLoggedIn, isLoading } = useAuth();
  return useQuery<TData, TVariables>(query, {
    ...options,
    skip: isLoading || !isLoggedIn || options.skip,
  });
}
